export default __webpack_public_path__ + "assets/audios/b3851a220f9dba77f74735d093cfb320.mp3";